<div *ngIf="this.mainSearchService.isSearching" class="fadeInUp1" when-visible="animateElementIn" when-not-visible="animateElementOut">
	<div class="center-block-wrap">
		<div class="pull-left" style="margin-top: 8px;">
			{{ 'typeSearch.searching' | translate }}	
		</div>				

	    <div class="pull-left m-l-5">
	      <mat-spinner [diameter]="20" class="button-spinner"></mat-spinner>
	    </div>  					
	</div>			
</div>

<div *ngIf="!this.mainSearchService.isSearching" 
	 when-visible="animateElementIn" 
	 when-not-visible="animateElementOut">
	<table class="striped data-table">
		<thead>
			<tr>	
				<th>
					<div class="flex-container-space-between-a-i-c m-l-r-10">
						<div>
							{{ 'typeSearch.search' | translate }}		

							({{ 'typeSearch.found' | translate }}: {{mainSearchService.totalFound}}, {{ 'typeSearch.pages' | translate }}: {{mainSearchService.pages}})		
						</div>
						<div>
							<a (click)="closeSearch()" class="c-p">{{ 'typeSearch.close' | translate }}</a>
						</div>
					</div>	
				</th>
			</tr>
		</thead>	
		<tbody>	
			<tr *ngFor="let item of mainSearchService.list" class="fadein">
				<td class="col s2 m2 l2">
					<div class="flex-container-space-between-a-i-c">
				        <div>
		        			<strong>{{ 'typeSearch.agency' | translate }}:</strong> {{item.ParentCategoryLabel | ml:multiLanguageService.retrigger}}
		        			<br/>
		        			<strong>{{ 'typeSearch.category' | translate }}:</strong> {{item.CategoryLabel | ml:multiLanguageService.retrigger}}
		        			<br/>
		        			<strong>{{ 'typeSearch.transactionType' | translate }}:</strong> {{item.ProcessName | ml:multiLanguageService.retrigger}}						        			
				        </div>		

			        	<div>
							<button class="pull-left" mat-raised-button color="primary"   
								    (click)="mainSearchService.gotoUrl(item)">
								{{ 'typeSearch.view' | translate }}
							</button>  			        		
			        	</div>
					</div>		
				</td>
			</tr>
		</tbody>					
	</table>					
</div>
